module.exports = __webpack_public_path__ + "static/media/ENTRANCE-FINAL-Model-3.a001a9f7.webp";